import styled from 'styled-components';
import React, { memo } from 'react';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

declare global {
  interface Window {
    HubSpotConversations?: {
      widget?: {
        open: () => void;
      };
    };
    mavenoid?: {
      push: (event: { event: string; clientId?: string }) => void;
    };
  }
}

interface ChatButtonProps {
  buttonText?: string;
}

interface ChatFooterProps {
  footerText?: string;
}

export const openHubspotChat = (): void => {
  // HubSpotConversations is loaded from https://js.hs-scripts.com/###.js
  // and will only load on allowed domains from hubspot admin
  window.HubSpotConversations?.widget?.open();
};

export const openMavenoidChat = (): void => {
  window?.mavenoid?.push({
    event: 'assistant-open',
  });
};

const ChatButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme?.notificationBanner?.text ?? '#fff'};
  fill: ${({ theme }) => theme?.notificationBanner?.text ?? '#fff'};
  line-height: 1.5;
  padding: 0;
  margin: 0 0.625rem 0 0;
  &:hover {
    text-decoration: underline;
  }
  svg {
    position: relative;
    top: 3px;
  }
`;

const ChatText = styled(ChatButton)`
  color: inherit;
  font-weight: inherit;
  padding: 0;
  margin: 0;
`;

export const HubspotChatButton = memo(() => {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <ChatButton type="button" onClick={openHubspotChat}>
      {tt(s => s.openChatWidgetComponent.startChatButton)}
    </ChatButton>
  );
});

export const HubspotChatFooter = memo(() => {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <ChatText type="button" onClick={openHubspotChat}>
      {tt(s => s.openChatWidgetComponent.startChatButton)}
    </ChatText>
  );
});

export const MavenoidChatButton = memo(({ buttonText }) => {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <ChatButton type="button" onClick={openMavenoidChat}>
      {buttonText ?? tt(s => s.openChatWidgetComponent.liveChatButton)}
    </ChatButton>
  );
});

export const MavenoidChatFooter = memo(({ footerText }) => {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <ChatText type="button" onClick={openMavenoidChat}>
      {footerText ?? tt(s => s.openChatWidgetComponent.chatWithAgentNowButton)}
    </ChatText>
  );
});
